import React from 'react';
import { Text as Txt } from 'react-native';
import * as Styles from '../utils/Styles';

const Text = props => <Txt style={[{ color: Styles.appColor1 }, props.style]}>{props.children}</Txt>;

export default Text;
